const anchorSelector = '[data-home-anchor-scroll]';
const initializedAnchors = new WeakSet();

const findTarget = (hash) => {
  try {
    return document.querySelector(hash);
  } catch {
    return null;
  }
};

const initHomeAnchorScroll = (scope = document) => {
  scope.querySelectorAll(anchorSelector).forEach((anchor) => {
    if (initializedAnchors.has(anchor)) {
      return;
    }

    const hash = anchor.getAttribute('href');
    if (!hash || hash === '#' || !hash.startsWith('#') || !findTarget(hash)) {
      return;
    }

    initializedAnchors.add(anchor);
    anchor.addEventListener('click', (event) => {
      if (typeof window.scrollToEl !== 'function' || !findTarget(hash)) {
        return;
      }

      event.preventDefault();
      window.history?.pushState(null, '', hash);
      window.scrollToEl(`${hash}|600`);
    });
  });
};

initHomeAnchorScroll();
